"use client";

import React from "react";
import dynamic from "next/dynamic";

const ResponsiveBrandSlider = dynamic(
  () => import("@/components/ResponsiveBrandSlider"),
  { ssr: false },
);

const BrandsPage = () => {
  return (
    <>
      <section className="our-brands-page">
        <ResponsiveBrandSlider />
      </section>
    </>
  );
};

export default BrandsPage;
